const isImage = /\S+\.(jpg|jpeg|png|gif)(\?.+)?$/;
const isZip = /^\S+\.zip(\?.+)?$/;
const isEmoji = /\p{Emoji_Presentation}/gu;
const isTagCommand = /@\w+/;
const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export { isImage, isZip, isEmoji, isTagCommand, isEmail };
